import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-follow-unlock',
  templateUrl: './follow-unlock.component.html',
  styleUrls: [
    './follow-unlock.component.scss'
  ]
})
export class FollowUnlockComponent {

  @Input()
  label: string;

  @Input()
  isBlock: boolean;

  @Output()
  followClick: EventEmitter<boolean> = new EventEmitter<boolean>()

  follow(): void {
    this.followClick.emit(true);
  }
}
